import { useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";

import { BomDetails } from "@/components/projects/diagnostic/bom/BomDetails";

/**
 * O ajuste da BOM vigente no nó da BOM do Functional (#1480).
 *
 * Na reunião de 19/10/2026 o Marco pediu que o "Ver detalhes e ajustar" saísse
 * do Diagnóstico, que é a tela do cliente e não pode mostrar preço de lista da
 * SAP, e viesse para onde a BOM é gerada, ao lado do upload do Pricing App. O
 * detalhe é o mesmo componente; aqui ele nasce fechado, porque o nó já tem o
 * payload da execução embaixo.
 */
export function BomAdjustPanel() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const Icon = open ? ChevronDown : ChevronRight;

  return (
    <div data-testid="bom-adjust-panel" className="rounded-lg border border-[#e8ebf0] bg-white">
      <button
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        className="flex w-full items-center gap-2 px-4 py-3 text-left text-[13px] font-semibold text-[#08254c] hover:bg-[#f7f8fa]"
      >
        <Icon aria-hidden className="h-4 w-4" />
        {t("See details and adjust")}
      </button>
      {open && (
        <div className="border-t border-[#e8ebf0] px-4 py-3">
          <BomDetails />
        </div>
      )}
    </div>
  );
}
